import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { X, Copy, Check, AlarmClock } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

const SEEN_KEY = "drelo_recovery_seen";

export default function CartRecovery() {
  const { items, subtotal, setOpen } = useCart();
  const nav = useNavigate();
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const armed = useRef(false);

  useEffect(() => {
    const onLeave = (e) => {
      if (e.clientY <= 0 && items.length > 0 && !sessionStorage.getItem(SEEN_KEY) && !armed.current) {
        armed.current = true;
        setShow(true);
      }
    };
    document.addEventListener("mouseleave", onLeave);
    return () => document.removeEventListener("mouseleave", onLeave);
  }, [items]);

  const close = () => { sessionStorage.setItem(SEEN_KEY, "1"); setShow(false); };

  const copyCode = () => {
    navigator.clipboard.writeText("VUELVE15");
    setCopied(true);
    toast.success("¡Cupón VUELVE15 copiado! 🎉");
    setTimeout(() => setCopied(false), 1500);
  };

  const goCheckout = () => { sessionStorage.setItem(SEEN_KEY, "1"); setShow(false); nav("/carrito"); };

  if (!show || items.length === 0) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 grid place-items-center p-4 animate-rise" data-testid="cart-recovery-popup">
      <div className="bg-white rounded-2xl w-full max-w-md overflow-hidden relative shadow-2xl">
        <button onClick={close} className="absolute top-3 right-3 z-10 bg-white/80 rounded-full p-1" data-testid="recovery-close"><X className="w-5 h-5" /></button>
        <div className="bg-drelo-urgency text-white p-6 text-center">
          <AlarmClock className="w-12 h-12 mx-auto mb-2 animate-shake" />
          <h2 className="font-display font-black text-2xl uppercase leading-none">¡Espera! 🛑</h2>
          <p className="text-white/90 text-sm mt-2">Tu carrito de <b>${subtotal.toFixed(2)}</b> está a punto de perderse. Termina tu compra antes de salir.</p>
        </div>
        <div className="p-6 text-center">
          <p className="text-sm text-drelo-muted">Llévate un <b className="text-drelo-ink">15% EXTRA</b> ahora mismo con este cupón:</p>
          <button onClick={copyCode} className="mt-3 w-full border-2 border-dashed border-drelo-primary text-drelo-primary rounded-xl py-3 font-display font-black text-xl tracking-widest flex items-center justify-center gap-2 hover:bg-orange-50" data-testid="recovery-copy-code">
            {copied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />} VUELVE15
          </button>
          <button onClick={goCheckout} className="mt-3 w-full bg-drelo-primary text-white py-3.5 rounded-xl font-black uppercase tracking-wide hover:bg-drelo-hover" data-testid="recovery-checkout">Completar mi compra</button>
          <button onClick={close} className="text-xs text-drelo-muted mt-3 hover:underline">No, prefiero pagar el precio completo después</button>
        </div>
      </div>
    </div>
  );
}
